import { jsx as _jsx } from "react/jsx-runtime";
import createSvgIcon from "./utils/createSvgIcon";
export default createSvgIcon([
    /*#__PURE__*/ _jsx("path", {
        fill: "#690C77",
        d: "M39.9763 24.9586c-.4793 0-.9054-.3728-.9054-.9054 0-.4792.3728-.9053.9054-.9053h1.9704C41.5207 13.9349 34.2248 6.5325 25.0651 6v2.077c0 .4792-.3728.9053-.9054.9053-.4793 0-.9053-.3728-.9053-.9054V6C13.8816 6.3728 6.3728 13.8284 6 23.2012h2.0237c.4793 0 .9053.3727.9053.9053 0 .4793-.3728.9053-.9053.9053H6C6.4793 34.2781 13.9881 41.6805 23.2544 42v-1.9172c0-.4793.3728-.9053.9053-.9053.4793 0 .9054.3727.9054.9053v1.8639c9.1065-.5325 16.4023-7.8816 16.8816-16.9881z"
    }, "0"),
    /*#__PURE__*/ _jsx("path", {
        fill: "#931CA0",
        d: "M39.0707 24.1064c0-.3195.1598-.5857.426-.7455-.3195-7.9349-6.6567-14.3787-14.5384-14.858-.1597.3196-.426.5326-.7988.5326s-.6923-.213-.7988-.5326c-8.0947.3196-14.5385 6.7633-14.9112 14.858.2662.1598.4793.426.4793.7988 0 .3195-.213.6391-.4793.7988.426 8.0414 6.923 14.432 15.0177 14.6982.1598-.213.426-.3728.6923-.3728s.5325.1598.6923.3728c7.8816-.426 14.2189-6.7633 14.6449-14.6982-.2662-.2662-.426-.5326-.426-.8521"
    }, "1"),
    /*#__PURE__*/ _jsx("path", {
        fill: "#C057C9",
        d: "M23.9465 33.3725c5.1765 0 9.3728-4.1964 9.3728-9.3728s-4.1963-9.3727-9.3728-9.3727-9.3728 4.1963-9.3728 9.3727 4.1964 9.3728 9.3728 9.3728"
    }, "2"),
    /*#__PURE__*/ _jsx("path", {
        fill: "#DE91E2",
        d: "M23.9463 30.3904c3.5294 0 6.3905-2.8611 6.3905-6.3905s-2.8611-6.3905-6.3905-6.3905-6.3905 2.8611-6.3905 6.3905 2.8611 6.3905 6.3905 6.3905"
    }, "3"),
    /*#__PURE__*/ _jsx("path", {
        fill: "#42003D",
        d: "m25.8641 26.9293-.4793-1.3314h-2.3965l-.4792 1.3314h-1.6509l2.6094-6.7633h1.4379l2.5562 6.7633zm-1.6509-4.9527-.7988 2.3432h1.5443z"
    }, "4")
], "AppAudiences", {
    "style": {
        "fill": "none"
    },
    "viewBox": "0 0 48 48"
});
